import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { selectToken } from '../../util/tokenSelector.js';
import toRgbColor from '../../util/toRgbColor.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var textLinkInteractiveState = function textLinkInteractiveState(theme, color) {
  var textColorToken = selectToken(theme.text, color);
  var spacing = {
    borderRadius: selectToken(theme.radius, '2'),
    padding: "0 ".concat(selectToken(theme.spacing, '2'))
  };
  if (!textColorToken) return null;
  var textColorTokenRgb = toRgbColor(textColorToken);
  var textColorRgb = "".concat(textColorTokenRgb.red, ", ").concat(textColorTokenRgb.green, ", ").concat(textColorTokenRgb.blue);
  return _objectSpread(_objectSpread({
    outlineColor: 'transparent'
  }, spacing), {}, {
    '&:active': {
      backgroundColor: "rgba(".concat(textColorRgb, ", 0.16)")
    },
    '&:focus-visible': {
      // TODO: ADSWEB-729 Token for outline width
      boxShadow: "0 0 0 4px ".concat(textColorToken),
      outline: 'none'
    }
  });
};

export { textLinkInteractiveState as default };
//# sourceMappingURL=textLinkInteractiveState.js.map
